import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const ColumnStatus = ({ isActive }) => {
  const { t } = useTranslation('user');
  const status = isActive ? t('statusActive') : t('statusInactive');

  return (
    <Box className={styles['column-status__wrapper']}>
      <Box className={isActive ? styles['column-status__container--success'] : styles['column-status__container--error']}>
        <TextRegular className={isActive ? styles['column-status__text--success'] : styles['column-status__text--error']}>{status}</TextRegular>
      </Box>
    </Box>
  );
};

export default ColumnStatus;